import { create } from 'zustand';

export type ThemeMode = 'system' | 'light' | 'dark';

const ORDER: ThemeMode[] = ['system', 'light', 'dark'];

const applyMode = (mode: ThemeMode) => {
  const root = document.documentElement;
  if (mode === 'system') {
    root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', mode);
  }
};

interface ThemeModeState {
  mode: ThemeMode;
  cycleMode: () => void;
  setMode: (mode: ThemeMode) => void;
}

/** Gallery-local theme mode for smart screens (data-theme on <html>). */
export const useThemeModeStore = create<ThemeModeState>((set, get) => ({
  mode: 'light',
  setMode: (mode) => {
    applyMode(mode);
    set({ mode });
  },
  cycleMode: () => {
    const current = get().mode;
    const next = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length];
    applyMode(next);
    set({ mode: next });
  },
}));
